



















































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { copyToClipboard } from 'quasar'
import stringRandom from 'src/assets/stringRandomUppercase'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    ModalDialog
  }
})
export default class ItemSignupCodeButton extends Vue {
  loading = false

  @Prop()
  readonly code!: string | null

  @Prop({ default: false })
  readonly link!: boolean

  @Prop({ default: '' })
  readonly color!: string

  @Prop({ default: 'md' })
  readonly size!: string

  @Ref()
  readonly dialog!: ModalDialog

  get codeToDisplay () {
    const code = this.code || ''
    return (code.match(/.{1,3}/g) || ['']).join(' ')
  }

  @Watch('code')
  afterRegenerate () {
    this.loading = false
  }

  async copyToClipboard (value: string) {
    this.loading = true
    await copyToClipboard(value)
    this.loading = false
  }

  async qrcode (value: string) {

  }

  init () {
    if (!this.code) {
      this.regenerate()
    }
  }

  regenerate () {
    this.loading = true
    this.$emit('regenerate', stringRandom(8))
  }
}
